import React, { Component, Fragment } from "react";

import InfoBoard1 from "./InfoBoard1";
import InfoBoard2 from "./InfoBoard2";
import InfoBoard3 from "./InfoBoard3";
import InfoBoard4 from "./InfoBoard4";
import InfoBoard5 from "./InfoBoard5";
import InfoBoard6 from "./InfoBoard6";

export default class InfoBoardRow extends Component {
    getContent = function () {
        const {
            data,
            extendedData,
            id,
            isEditable,
            name,
            globalSettings,
            sortIndex
        } = this.props;
        let content = null;
        if (!id) {
            return content;
        }

        switch (id) {
            case 1:
                return (
                    <InfoBoard1
                        data={data}
                        extendedData={extendedData}
                        globalSettings={globalSettings}
                        isEditable={isEditable}
                        calculatedValues={[]}
                        name={name}
                        onChange={this.props.onChange}
                        sortIndex={sortIndex}
                    />
                );

            case 2:
                return (
                    <InfoBoard2
                        data={data}
                        extendedData={extendedData}
                        globalSettings={globalSettings}
                        isEditable={isEditable}
                        calculatedValues={[]}
                        name={name}
                        onChange={this.props.onChange}
                        sortIndex={sortIndex}
                    />
                );

            case 3:
                return (
                    <InfoBoard3
                        data={data}
                        extendedData={extendedData}
                        globalSettings={globalSettings}
                        isEditable={isEditable}
                        calculatedValues={[]}
                        name={name}
                        onChange={this.props.onChange}
                        sortIndex={sortIndex}
                    />
                );

            case 4:
                return (
                    <InfoBoard4
                        data={data}
                        extendedData={extendedData}
                        globalSettings={globalSettings}
                        isEditable={isEditable}
                        calculatedValues={[]}
                        name={name}
                        onChange={this.props.onChange}
                        sortIndex={sortIndex}
                    />
                );

            case 5:
                return (
                    <InfoBoard5
                        data={data}
                        extendedData={extendedData}
                        globalSettings={globalSettings}
                        isEditable={isEditable}
                        calculatedValues={[]}
                        name={name}
                        onChange={this.props.onChange}
                        sortIndex={sortIndex}
                    />
                );

            case 6:
                return (
                    <InfoBoard6
                        data={data}
                        extendedData={extendedData}
                        globalSettings={globalSettings}
                        isEditable={isEditable}
                        calculatedValues={[]}
                        name={name}
                        onChange={this.props.onChange}
                        sortIndex={sortIndex}
                    />
                );
        }

        return content;
    };

    render() {
        const { showInfoBoard } = this.props;
        let classList = "infoBoardContainer"
        if (showInfoBoard) {

            classList += " visible";
        }

        return (
            <section className={classList}>
                {this.getContent()}
            </section>
        );
    }
}
